<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo API</span>
    </div>

    <div v-if="tipoIdPaiLocale === 8">
      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <v-textarea
      v-model="nodeDataLocale.apiInfo.apiUrl"
      class="mt-2"
      label="URL da API *"
      placeholder="Digite sua URL"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      :rules="[validators.required, (v) => (!!v && v.length <= 2000) || 'Máximo de 2000 caracteres', validators.isUrlValida]"
      @change="nodeConfig"
    />

    <v-select
      v-model="nodeDataLocale.apiInfo.apiVerboId"
      class="mt-2"
      outlined
      clearable
      label="Verbo http *"
      placeholder="Selecione um verbo http"
      no-data-text="Nenhuma tipo de verbo http encontrado"
      item-text="nome"
      item-value="id"
      :items="tiposDeVerbos"
      :rules="[validators.select]"
      @change="nodeConfig"
    />

    <v-select
      v-model="nodeDataLocale.apiInfo.apiTipoAutorizacaoId"
      class="mt-2"
      outlined
      clearable
      label="Tipo de autorização *"
      placeholder="Selecione um tipo de autorização"
      no-data-text="Nenhum tipo de autorização disponível"
      item-text="nome"
      item-value="id"
      :items="tiposDeAutorizacoes"
      :rules="[validators.select]"
      @change="nodeConfig"
    />

    <v-expand-transition>
      <v-textarea
        v-if="isTipoAutorizacaoBearerTokenSelected"
        v-model="nodeDataLocale.apiInfo.apiBearerToken"
        class="mt-2"
        outlined
        label="Token *"
        placeholder="Digite o token"
        auto-grow
        rows="1"
        row-height="15"
        :rules="[validators.required, (v) => (!!v && v.length <= 200) || 'Máximo de 200 caracteres']"
      />

      <div v-else-if="isTipoAutorizacaoBasicAuthSelected">
        <v-text-field
          v-model="nodeDataLocale.apiInfo.apiUserName"
          class="mt-2"
          outlined
          label="Usuário *"
          placeholder="Digite o usuário"
          :rules="[validators.required, (v) => (!!v && v.length <= 200) || 'Máximo de 200 caracteres']"
          @change="nodeConfig"
        />

        <v-text-field
          v-model="nodeDataLocale.apiInfo.apiPassword"
          class="mt-2"
          outlined
          label="Senha *"
          placeholder="Digite a senha"
          :rules="[validators.required, (v) => (!!v && v.length <= 200) || 'Máximo de 200 caracteres']"
          @change="nodeConfig"
        />
      </div>
    </v-expand-transition>

    <v-radio-group
      v-model="nodeDataLocale.apiInfo.apiTipoParametroId"
      class="mt-2"
      label="Tipo de parâmetro *"
      mandatory
      @change="nodeConfig"
    >
      <v-radio
        v-for="(tipo, index) in tiposDeParametros"
        :key="index"
        :label="tipo.nome"
        :value="tipo.id"
      />
    </v-radio-group>

    <v-expand-transition>
      <v-textarea
        v-if="isTipoParametroBody"
        v-model="nodeDataLocale.apiInfo.apiParametroJsonBody"
        class="mt-2"
        outlined
        label="JSON *"
        placeholder="Digite o JSON"
        auto-grow
        rows="1"
        row-height="15"
        :rules="[validators.required, (v) => (!!v && v.length <= 2000) || 'Máximo de 2000 caracteres']"
      />

      <div
        v-else-if="isTipoParametroLista"
        class="mb-4"
      >
        <tabela-de-parametros
          :parametros.sync="nodeDataLocale.apiInfo.parametros"
        />
      </div>
    </v-expand-transition>

    <v-text-field
      v-model="nodeDataLocale.apiInfo.apiResponseProperty"
      class="mt-2"
      outlined
      label="Nome campo response com a resposta da API *"
      placeholder="Digite o campo response"
      :rules="[validators.required, (v) => (!!v && v.length <= 200) || 'Máximo de 200 caracteres']"
    />
  </div>
</template>

<script>
import { ref, computed, inject, watch } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'
import ChatBotTipoNoApiVerboTiposEnum from '@/models/entities/chat-bot/ChatBotTipoNoApiVerboTiposEnum'
import ChatBotTipoNoApiAutorizacaoTiposEnum from '@/models/entities/chat-bot/ChatBotTipoNoApiAutorizacaoTiposEnum'
import ChatBotTipoNoApiParametroTiposEnum from '@/models/entities/chat-bot/ChatBotTipoNoApiParametroTiposEnum'
import TabelaDeParametros from './TabelaDeParametros.vue'
import { isUrlValida } from '@/utils/validation'

export default {
  components: {
    TabelaDeParametros,
  },

  setup(props, { emit }) {
    const tiposDeVerbos = [
      { id: ChatBotTipoNoApiVerboTiposEnum.Get, nome: 'Get' },
      { id: ChatBotTipoNoApiVerboTiposEnum.Post, nome: 'Post' },
      { id: ChatBotTipoNoApiVerboTiposEnum.Put, nome: 'Put' },
      { id: ChatBotTipoNoApiVerboTiposEnum.Delete, nome: 'Delete' },
    ]
    const tiposDeAutorizacoes = [
      { id: ChatBotTipoNoApiAutorizacaoTiposEnum.BearerToken, nome: 'Bearer Token' },
      { id: ChatBotTipoNoApiAutorizacaoTiposEnum.BasicAuth, nome: 'Basic Auth' },
    ]
    const tiposDeParametros = [
      { id: ChatBotTipoNoApiParametroTiposEnum.SemParametros, nome: 'Sem parâmetros' },
      { id: ChatBotTipoNoApiParametroTiposEnum.Body, nome: 'Body' },
      { id: ChatBotTipoNoApiParametroTiposEnum.Lista, nome: 'Lista' },
    ]

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')

    const isTipoAutorizacaoBearerTokenSelected = computed(() => nodeDataLocale.value.apiInfo.apiTipoAutorizacaoId === ChatBotTipoNoApiAutorizacaoTiposEnum.BearerToken)
    const isTipoAutorizacaoBasicAuthSelected = computed(() => nodeDataLocale.value.apiInfo.apiTipoAutorizacaoId === ChatBotTipoNoApiAutorizacaoTiposEnum.BasicAuth)

    const isTipoParametroBody = computed(() => nodeDataLocale.value.apiInfo.apiTipoParametroId === ChatBotTipoNoApiParametroTiposEnum.Body)
    const isTipoParametroLista = computed(() => nodeDataLocale.value.apiInfo.apiTipoParametroId === ChatBotTipoNoApiParametroTiposEnum.Lista)
    const isTipoParametroSemParametros = computed(() => nodeDataLocale.value.apiInfo.apiTipoParametroId === ChatBotTipoNoApiParametroTiposEnum.SemParametros)

    function nodeConfig() {
      emit('node-config')
    }

    watch(
      () => nodeData.value,
      value => {
        nodeDataLocale.value = value
      },
      { immediate: true, deep: true },
    )

    watch(
      () => tipoIdPai.value,
      value => {
        tipoIdPaiLocale.value = value
      },
      { immediate: true, deep: true },
    )

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,
      tiposDeVerbos,
      tiposDeAutorizacoes,
      tiposDeParametros,

      isTipoAutorizacaoBearerTokenSelected,
      isTipoAutorizacaoBasicAuthSelected,
      isTipoParametroBody,
      isTipoParametroLista,
      isTipoParametroSemParametros,

      validators: {
        required,
        select,
        isUrlValida,
      },
    }
  },
}
</script>
